// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"702":"css/admin-app.7095","2278":"css/app.7095"}[chunkId] + ".css";
};